export const menuData = [

  // OFFERS
  {
    id: 1,
    category:"offer",
    name: "Акција - Чикен чизбургер + мали помфрит + кока кола 0,33",
    subtitle: "",
    desc: "150г паниране пилетине, 2x трапист сир, фета сир, микс салата, сосеви",
    grams: "",
    price: "720",
    image: "https://idzuo.com/menuImages/offers/offer-01.png ",
    cart: "Додајте у корпу",
  },
  {
    id: 2,
    category:"offer",
    name: "Акција - 2 x Classic Idzuo smash + мали помфрит",
    subtitle: "",
    desc: "2x 70г 100% јунеће месо, 2x чедар сир, црвени сос, сенф, црвени лук, кисели краставац",
    grams: "",
    price: "1040",
    image: "https://idzuo.com/menuImages/offers/offer-02.png",
    cart: "Додајте у корпу",
  },
  {
    id: 3,
    category:"offer",
    name: "Акција - Омлет са панчетом у тортиљи",
    subtitle: "",
    desc: "2 јаја, панчета, фета сир, кисели краставчићи, микс салата, сосеви",
    grams: "",
    price: "288",
    image: "https://idzuo.com/menuImages/breakfast/omlet_sa_pancetom_u_tortilji.jpg",
    cart: "Додајте у корпу",
  },    

  // BREAKFAST
  {
    id: 4,
    category:"breakfast",
    name: "Омлет у тортиљи",
    subtitle: "Тортиља",
    desc: "2 јаја, фета сир, кисели краставчићи, микс салата, сосеви",
    grams: "",
    price: "250",
    image: "https://idzuo.com/menuImages/breakfast/omlet_u_tortilji.jpg",
    cart: "Додајте у корпу",
  },
  {
    id: 5,
    category:"breakfast",
    name: "Омлет на тањиру",
    subtitle: "Taњир",
    desc: "3 јаја, фета сир, микс салата, ½ тортиље",
    grams: "",
    price: "280",
    image: "https://idzuo.com/menuImages/breakfast/omlet.avif",
    cart: "Додајте у корпу",
  },

  {
    id: 6,
    category:"breakfast",
    name: "Омлет са панчетом у тортиљи",
    subtitle: "Тортиља",
    desc: "2 јаја, панчета, фета сир, кисели краставчићи, микс салата, сосеви",
    grams: "",
    price: "320",
    image: "https://idzuo.com/menuImages/breakfast/omlet_sa_pancetom_u_tortilji.jpg",
    cart: "Додајте у корпу",
  },
  {
    id: 7,
    category:"breakfast",
    name: "Омлет са панчетом на тањиру",
    subtitle: "Taњир",
    desc: "3 јаја, панчета, фета сир, микс салата, ½ тортиље",
    grams: "",
    price: "350",
    image: "https://idzuo.com/menuImages/breakfast/omlet_sa_pancetom.avif",
    cart: "Додајте у корпу",
  },

  {
    id: 8,
    category:"breakfast",
    name: "Омлет са печеницом у тортиљи",
    subtitle: "Тортиља",
    desc: "2 јаја, печеница, фета сир, кисели краставчићи, микс салата, сосеви",
    grams: "",
    price: "280",
    image: "https://idzuo.com/menuImages/breakfast/omlet_sa_pecenicom_u_tortilji.jpg",
    cart: "Додајте у корпу",
  },
  {
    id: 9,
    category:"breakfast",
    name: "Омлет са печеницом на тањиру",
    subtitle: "Taњир",
    desc: "3 јаја, печеница, фета сир, микс салата, ½ тортиље",
    grams: "",
    price: "310",
    image: "https://idzuo.com/menuImages/breakfast/omlet_pecenica.avif",
    cart: "Додајте у корпу",
  },

  {
    id: 10,
    category:"breakfast",
    name: "Омлет са печуркама у тортиљи",
    subtitle: "Тортиља",
    desc: "2 јаја, печурке, фета сир, кисели краставчићи, микс салата, сосеви",
    grams: "",
    price: "270",
    image: "https://idzuo.com/menuImages/breakfast/omlet_sa_pecurkama_u_tortilji.jpg",
    cart: "Додајте у корпу",
  },
  {
    id: 11,
    category:"breakfast",
    name: "Омлет са печуркама на тањиру",
    subtitle: "Taњир",
    desc: "3 јаја, печурке, фета сир, микс салата, ½ тортиље",
    grams: "",
    price: "300",
    image: "https://idzuo.com/menuImages/breakfast/omlet_sa_pecurkama.avif",
    cart: "Додајте у корпу",
  },

  {
    id: 12,
    category:"breakfast",
    name: "Омлет са димљеном буткицом и печуркама у тортиљи",
    subtitle: "Тортиља",
    desc: "2 јаја, буткица, печурке, фета сир, кисели краставчићи, микс салата, сосеви",
    grams: "",
    price: "320",
    image: "https://idzuo.com/menuImages/breakfast/omlet_sa_butkicom_i_pecurkama_u_tortilji.jpg",
    cart: "Додајте у корпу",
  },
  {
    id: 13,
    category:"breakfast",
    name: "Омлет са димљеном буткицом и печуркама на тањиру",
    subtitle: "Taњир",
    desc: "3 јаја, буткица, печурке, фета сир, микс салата, ½ тортиље",
    grams: "",
    price: "350",
    image: "https://idzuo.com/menuImages/breakfast/omlet_butkica_pecurke.avif",
    cart: "Додајте у корпу",
  },

  {
    id: 14,
    category:"breakfast",
    name: "Омлет са кобасицом у тортиљи",
    subtitle: "Тортиља",
    desc: "2 јаја, кобасица са сиром, фета сир, кисели краставчићи, микс салата, сосеви",
    grams: "",
    price: "530",
    image: "https://idzuo.com/menuImages/breakfast/omlet_sa_kobasicom_tortilji.jpg",
    cart: "Додајте у корпу",
  },
  {
    id: 15,
    category:"breakfast",
    name: "Омлет са кобасицом на тањиру",
    subtitle: "Тортиља",
    desc: "3 јаја, аустријска кобасица са качкављем, фета сир, микс салата, ½ тортиље",
    grams: "",
    price: "540",
    image: "https://idzuo.com/menuImages/breakfast/omlet_sa_kobasicom_sa_kackavaljem_na_tanjiru.avif",
    cart: "Додајте у корпу",
  },

  // CHICKEN
  {
    id: 16,
    category:"chicken",
    name: "Пилетина у тортиљи",
    subtitle: "Тортиља",
    desc: "150г пилетине, фета сир, црвени лук, кисели краставчићи, микс салата, сосеви",
    grams: "",
    price: "420",
    image: "https://idzuo.com/menuImages/chicken/piletina_u_tortilji.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 17,
    category:"chicken",
    name: "Пилетина у лепињи",
    subtitle: "Лепиња",
    desc: "150г пилетине, фета сир, црвени лук, кисели краставчићи, микс салата, сосеви",
    grams: "",
    price: "420",
    image: "https://idzuo.com/menuImages/chicken/piletina_u_lepinji.webp",
    cart: "Додајте у корпу",
  },
  
  {
    id: 18,
    category:"chicken",
    name: "Пилетина са панчетом у тортиљи",
    subtitle: "Тортиља",
    desc: "150г пилетине, панчета, фета сир, црвени лук, кисели краставчићи, микс салата, сосеви ",
    grams: "",
    price: "470",
    image: "https://idzuo.com/menuImages/chicken/piletina_panceta_u_tortilji.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 19,
    category:"chicken",
    name: "Пилетина са панчетом у лепињи",
    subtitle: "Лепиња",
    desc: "150г пилетине, панчета, фета сир, црвени лук, кисели краставчићи, микс салата, сосеви",
    grams: "",
    price: "470",
    image: "https://idzuo.com/menuImages/chicken/piletina_panceta_u_lepinji.webp",
    cart: "Додајте у корпу",
  },

  {
    id: 20,
    category:"chicken",
    name: "Пилетина кватро формађи у тортиљи",
    subtitle: "Тортиља",
    desc: "150г пилетине, панчета, quattro formaggi сос, фета сир, црвени лук, кисели краставчићи, микс салата, сосеви",
    grams: "",
    price: "520",
    image: "https://idzuo.com/menuImages/chicken/piletina_quattro_formagio.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 21,
    category:"chicken",
    name: "Пилетина кватро формађи у лепињи",
    subtitle: "Лепиња",
    desc: "150г пилетине, панчета, quattro formaggi сос, фета сир, црвени лук, кисели краставчићи, микс салата, сосеви",
    grams: "",
    price: "520",
    image: "https://idzuo.com/menuImages/chicken/piletina_quattro_formagio_u_lepinji.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 22,
    category:"chicken",
    name: "Пилетина кватро формађи на тањиру",
    subtitle: "Тањир",
    desc: "250г пилетине, панчета, quattro formaggi сос, микс салата, помфрит, ½ тортиље, сосеви",
    grams: "",
    price: "620",
    image: "https://idzuo.com/menuImages/chicken/piletina_quattro_formagio_na_tanjiru.webp",
    cart: "Додајте у корпу",
  },

  {
    id: 23,
    category:"chicken",
    name: "Чикен бургер у лепињи",
    subtitle: "Лепиња",
    desc: "150г паниране пилетине, фета сир, микс салата, сосеви",
    grams: "",
    price: "400",
    image: "https://idzuo.com/menuImages/chicken/chicken_burger.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 24,
    category:"chicken",
    name: "Чикен чизбургер у лепињи",
    subtitle: "Лепиња",
    desc: "150г паниране пилетине, 2x трапист сир, фета сир, микс салата, сосеви",
    grams: "",
    price: "470",
    image: "https://idzuo.com/menuImages/chicken/cheese_burger_pileci.webp",
    cart: "Додајте у корпу",
  },

  // PORK
  {
    id: 25,
    category:"pork",
    name: "Димљена буткица у тортиљи",
    subtitle: "Тортиља",
    desc: "160г димљене буткице, фета сир, црвени лук, кисели краставчићи, микс салата, сосеви",
    grams: "",
    price: "520",
    image: "https://idzuo.com/menuImages/pork/dimljena-butkica.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 26,
    category:"pork",
    name: "Димљена буткица у лепињи",
    subtitle: "Тањир",
    desc: "160г димљене буткице, фета сир, црвени лук, кисели краставчићи, микс салата, сосеви",
    grams: "",
    price: "500",
    image: "https://idzuo.com/menuImages/vide-bg-img.jpg",
    cart: "Додајте у корпу",
  },
  {
    id: 27,
    category:"pork",
    name: "Цепкано прасе у лепињи",
    subtitle: "Лепиња",
    desc: "150г свињског меса, фета сир, микс салата, сосеви",
    grams: "",
    price: "530",
    image: "https://idzuo.com/menuImages/pork/cepkano_prase_u_lepinji.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 28,
    category:"pork",
    name: "Цепкано прасе у тортиљи",
    subtitle: "Тортиља",
    desc: "150г свињског меса, фета сир, микс салата, сосеви",
    grams: "",
    price: "530",
    image: "https://idzuo.com/menuImages/pork/dimljena-butkica.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 29,
    category:"pork",
    name: "Цепкано прасе на тањиру",
    subtitle: "Тањир",
    desc: "250г свињског меса, 1/2 тортиље, микс салата, сосеви, помфрит",
    grams: "",
    price: "590",
    image: "https://idzuo.com/menuImages/pork/cepkano_prase_na_tanjiru.webp",
    cart: "Додајте у корпу",
  },

  // BURGER
  {
    id: 30,
    category:"burger",
    name: "Бургер у тортиљи",
    subtitle: "Тортиља",
    desc: "150г телећег меса, фета сир, црвени лук, кисели краставчићи, сосеви",
    grams: "",
    price: "370",
    image: "https://idzuo.com/menuImages/burgers/burger_u_tortilji.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 31,
    category:"burger",
    name: "Бургер у лепињи",
    subtitle: "Лепиња",
    desc: "150г телећег меса, фета сир, црвени лук, кисели краставчићи, сосеви",
    grams: "",
    price: "370",
    image: "https://idzuo.com/menuImages/burgers/burger.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 32,
    category:"burger",
    name: "Чизбургер у тортиљи",
    subtitle: "Тортиља",
    desc: "150г телећег меса, трапист сир, фета сир, црвени лук, кисели краставчићи, микс салата, сосеви",
    grams: "",
    price: "450",
    image: "https://idzuo.com/menuImages/burgers/cheese_burger_u_tortilji.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 33,
    category:"burger",
    name: "Чизбургер у лепињи",
    subtitle: "Лепиња",
    desc: "150г телећег меса, трапист сир, фета сир, црвени лук, кисели краставчићи, микс салата, сосеви",
    grams: "",
    price: "450",
    image: "https://idzuo.com/menuImages/burgers/cheese_burger.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 34,
    category:"burger",
    name: "Чизбургер кватро формађи у тортиљи",
    subtitle: "Тортиља",
    desc: "150г телећег меса, quattro formaggi сос, фета сир, црвени лук, кисели краставчићи, микс салата, сосеви",
    grams: "",
    price: "470",
    image: "https://idzuo.com/menuImages/burgers/cheese_burger_quattro_formagio.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 35,
    category:"burger",
    name: "Чизбургер кватро формађи у лепињи",
    subtitle: "Лепиња",
    desc: "150г телећег меса, quattro formaggi сос, фета сир, црвени лук, кисели краставчићи, микс салата, сосеви",
    grams: "",
    price: "470",
    image: "https://idzuo.com/menuImages/burgers/burger_quattro_formagio.webp",
    cart: "Додајте у корпу",
  },

  // BEEF
  {
    id: 36,
    category:"beef",
    name: "Рамстек у тортиљи",
    subtitle: "Тортиља",
    desc: "160г рамстека, фета сир, црвени лук, кисели краставчићи, микс салата, сосеви",
    grams: "",
    price: "760",
    image: "https://idzuo.com/menuImages/beef/rebrilja.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 37,
    category:"beef",
    name: "Рамстек",
    subtitle: "Тањир",
    desc: "300г рамстека, микс салата, помфрит, ½ тортиље",
    grams: "",
    price: "1050",
    image: "https://idzuo.com/menuImages/beef/piletina_na_tanjiru.webp",
    cart: "Додајте у корпу",
  },

  // BARBECUE
  {
    id: 38,
    category:"barbecue",
    name: "Лесковачки уштипци у тортиљи",
    subtitle: "Тортиља",
    desc: "150г телећег меса, панчета, гауда, фета сир, црвени лук, кисели краставчићи, микс салата, сосеви",
    grams: "",
    price: "490",
    image: "https://idzuo.com/menuImages/barbeque/leskovacki_ustipak_u_tortilji.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 39,
    category:"barbecue",
    name: "Лесковачки уштипци на тањиру",
    subtitle: "Тањир",
    desc: "300г телећег меса, панчета, гауда, микс салата, помфрит, ½ тортиље",
    grams: "",
    price: "560",
    image: "https://idzuo.com/menuImages/barbeque/leskovacki_ustipak.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 40,
    category:"barbecue",
    name: "Ћевапи у тортиљи",
    subtitle: "Тортиља",
    desc: "250г телећег меса, фета сир, црвени лук, љута туцана, сосеви",
    grams: "",
    price: "480",
    image: "https://idzuo.com/menuImages/barbeque/cevapi_u_tortiljji.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 41,
    category:"barbecue",
    name: "Ћевапи на тањиру",
    subtitle: "Тањир",
    desc: "300г телећег меса, микс салата, помфрит, ½ тортиље",
    grams: "",
    price: "570",
    image: "https://idzuo.com/menuImages/barbeque/cevapi.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 42,
    category:"barbecue",
    name: "Пуњена пљескавица у тортиљи",
    subtitle: "Тортиља",
    desc: "150г телећег меса, панчета, трапист сир, фета сир, црвени лук, кисели краставчићи, микс салата, сосеви",
    grams: "",
    price: "470",
    image: "https://idzuo.com/menuImages/barbeque/punjena_pljeskavica_u_tortilji.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 43,
    category:"barbecue",
    name: "Пуњена пљескавица на тањиру",
    subtitle: "Тањир",
    desc: "250г телећег меса, микс салата, помфрит, ½ тортиље",
    grams: "",
    price: "550",
    image: "https://idzuo.com/menuImages/barbeque/punjena_pljeskavica.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 44,
    category:"barbecue",
    name: "Пуњени ћевап у тортиљи ",
    subtitle: "Тортиља",
    desc: "150г телећег меса, quattri formaggi сос, печеница, фета сир, црвени лук, кисели краставчићи, микс салата, сосеви",
    grams: "",
    price: "510",
    image: "https://idzuo.com/menuImages/barbeque/punjena_pljeskavica_u_tortilji.webp",
    cart: "Додајте у корпу",
  },

  // SAUSAGE
  {
    id: 45,
    category:"sausage",
    name: "Кобасица са качкаваљем на тањиру",
    subtitle: "Тањир",
    desc: "Аустријска кобасица, помфрит, салата, ½ тортиље",
    grams: "",
    price: "530",
    image: "https://idzuo.com/menuImages/sausage/kobasica_sa_kackavaljem_na_tanjiru.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 46,
    category:"sausage",
    name: "Кобасица са качкаваљом у тортиљи",
    subtitle: "Тортиља",
    desc: "Аустијска кобасица, фета сир, црвени лук, кисели краставчићи, микс салата, сосеви у тортиљи",
    grams: "",
    price: "510",
    image: "https://idzuo.com/menuImages/sausage/kobasica_sa_kackavaljem_u_tortilji.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 47,
    category:"sausage",
    name: "Љута кобасица са качкаваљем на тањиру",
    subtitle: "Тањир",
    desc: "Аустријска кобасица, помфрит, салата, ½ тортиље",
    grams: "",
    price: "530",
    image: "https://idzuo.com/menuImages/sausage/ljuta_kobasica_sa_kackavaljem_na_tanjiru.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 48,
    category:"sausage",
    name: "Љута кобасица са качкаваљем у тортиљи",
    subtitle: "Тортиља",
    desc: "Аустијска кобасица, фета сир, црвени лук, кисели краставчићи, микс салата, сосеви у тортиљи",
    grams: "",
    price: "510",
    image: "https://idzuo.com/menuImages/sausage/ljuta_kobasica_sa_kackavaljem_u_tortilji.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 49,
    category:"sausage",
    name: "Пикантна кобасица на тањиру",
    subtitle: "Тањир",
    desc: "Аустријска кобасица, помфрит, салата, ½ тортиље црвени сос, бели сос",
    grams: "",
    price: "480",
    image: "https://idzuo.com/menuImages/sausage/pikantna_kobasica_na_tanjiru.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 50,
    category:"sausage",
    name: "Пикантна кобасица у тортиљи",
    subtitle: "Тортиља",
    desc: "Аустријска кобасица, фета сир, црвени лук, кисели краставчићи, микс салата, сосеви у тортиљи",
    grams: "",
    price: "470",
    image: "https://idzuo.com/menuImages/sausage/pikantna_kobasica_u_tortilji.webp",
    cart: "Додајте у корпу",
  },

  // VEGAN
  {
    id: 51,
    category:"vegan",
    name: "Тортиља са печуркама (посно)",
    subtitle: "Тортиља",
    desc: "200г шампињона, микс салата, црвени сос",
    grams: "",
    price: "420",
    image: "https://idzuo.com/menuImages/vegan/salata_sa_pecurkama_u_tortilji.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 52,
    category:"vegan",
    name: "Вегетаријанска салата у тортиљи (посно)",
    subtitle: "Тортиља",
    desc: "Микс салата, аћето балзамико, морска со, маринада, маслиново уље",
    grams: "",
    price: "380",
    image: "https://idzuo.com/menuImages/vegan/vegeterijanska_salata_u_tortilji.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 53,
    category:"vegan",
    name: "Тортиља са комадима туне (посно)",
    subtitle: "Тортиља",
    desc: "Комади туне, црвени лук, микс салата, црвени сос",
    grams: "",
    price: "440",
    image: "https://idzuo.com/menuImages/vegan/tuna_salata_u_tortilji.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 54,
    category:"vegan",
    name: "Фиш бургер у тортиљи",
    subtitle: "Тортиља",
    desc: "Фиш бургер, црвени лук, микс салата, црвени сос",
    grams: "",
    price: "400",
    image: "https://idzuo.com/menuImages/vegan/fish_burger_u_tortilji.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 55,
    category:"vegan",
    name: "Фиш бургер у лепињи",
    subtitle: "Лепиња",
    desc: "Фиш бургер, црвени лук, микс салата, црвени сос",
    grams: "",
    price: "400",
    image: "https://idzuo.com/menuImages/vegan/fish_burger.webp",
    cart: "Додајте у корпу",
  },

  // SALADS
  {
    id: 56,
    category:"salad",
    name: "Вегетаријанска салата (посно)",
    subtitle: "Тањир",
    desc: "Микс 9 салата, аћето балсамико, морска со, маринада, маслиново уље",
    grams: "",
    price: "390",
    image: "https://idzuo.com/menuImages/salads/vegeterijanska_salata.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 57,
    category:"salad",
    name: "Вегетаријанска салата са печуркама (посно)",
    subtitle: "Тањир",
    desc: "150г печурака, микс 9 салата, аћето балзамико, морска со, маринада, црвени сос",
    grams: "",
    price: "450",
    image: "https://idzuo.com/menuImages/salads/salata_sa_pecurkama.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 58,
    category:"salad",
    name: "Идзуо салата са пилетином",
    subtitle: "Тањир",
    desc: "150г пилећег филеа, микс 9 салата, аћето балзамико, морска со, маринада, бели сос",
    grams: "",
    price: "460",
    image: "https://idzuo.com/menuImages/salads/salata_sa_piletinom.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 59,
    category:"salad",
    name: "Идзуо салата са хрскавом пилетином",
    subtitle: "Тањир",
    desc: "Хрскава пилетина, микс 9 салата, аћето балзамико, морска со, маринада, бели сос",
    grams: "",
    price: "460",
    image: "https://idzuo.com/menuImages/salads/salata_hrskava_piletina.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 60,
    category:"salad",
    name: "Идзуо салата са туном (посно)",
    subtitle: "Тањир",
    desc: "Комади туне, микс 9 салата, аћето балзамико, морска со, маринада, црвени сос",
    grams: "",
    price: "460",
    image: "https://idzuo.com/menuImages/salads/tuna_salata.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 61,
    category:"salad",
    name: "Идзуо салата са рамстеком",
    subtitle: "Тањир",
    desc: "170г рамстека, микс 9 салата, аћето, балзамико, морска со, маринада, црвени сос",
    grams: "",
    price: "640",
    image: "https://idzuo.com/menuImages/salads/salata_rebrilja.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 62,
    category:"salad",
    name: "Идзуо салата са буткицом",
    subtitle: "Тањир",
    desc: "150г димљене буткице, микс 9 салата, аћето балзамико, морска со, маринада, црвени сос",
    grams: "",
    price: "470",
    image: "https://idzuo.com/menuImages/salads/salata-sa-butkicom.webp",
    cart: "Додајте у корпу",
  },

  // SIDES
  {
    id: 63,
    category:"sides",
    name: "Бели сос",
    subtitle: "",
    desc: "50г",
    grams: "",
    price: "60",
    image: "https://idzuo.com/menuImages/sides/beli_sos.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 64,
    category:"sides",
    name: "Црвени сос",
    subtitle: "",
    desc: "50г",
    grams: "",
    price: "60",
    image: "https://idzuo.com/menuImages/sides/crveni_sos.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 65,
    category:"sides",
    name: "Чили сос",
    subtitle: "",
    desc: "50г",
    grams: "",
    price: "50",
    image: "https://idzuo.com/menuImages/sides/cili-sos.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 66,
    category:"sides",
    name: "BBQ сос",
    subtitle: "",
    desc: "50г",
    grams: "",
    price: "60",
    image: "https://idzuo.com/menuImages/sides/bbq-sos.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 67,
    category:"sides",
    name: "Слатко љути чили",
    subtitle: "",
    desc: "50г",
    grams: "",
    price: "50",
    image: "https://idzuo.com/menuImages/sides/cili-sos.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 68,
    category:"sides",
    name: "Кватро формађи",
    subtitle: "",
    desc: "50г",
    grams: "",
    price: "70",
    image: "https://idzuo.com/menuImages/sides/beli_sos.webp",
    cart: "Додајте у корпу",
  },    
  {
    id: 69,
    category:"sides",
    name: "Помфрит мали",
    subtitle: "",
    desc: "200г",
    grams: "",
    price: "200",
    image: "https://idzuo.com/menuImages/sides/pomfrit_mali.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 70,
    category:"sides",
    name: "Помфрит велики",
    subtitle: "",
    desc: "400г и два соса",
    grams: "",
    price: "320",
    image: "https://idzuo.com/menuImages/sides/pomfrit_veliki.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 71,
    category:"sides",
    name: "Тортиља са сиром и зачинима",
    subtitle: "",
    desc: "160г и два соса",
    grams: "",
    price: "190",
    image: "https://idzuo.com/menuImages/sides/tortilja_sa_sirom_i_zacinima.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 72,
    category:"sides",
    name: "Тортиља са сиром, зачинима и панчетом",
    subtitle: "",
    desc: "160г и два соса",
    grams: "",
    price: "240",
    image: "https://idzuo.com/menuImages/sides/tortilja_sa_sirom_i_zacinima.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 73,
    name: "Онион рингс",
    subtitle: "",
    desc: "250г",
    grams: "",
    price: "290",
    image: "https://idzuo.com/menuImages/smash/onion-rings.webp",
    cart: "Додајте у корпу",
  },

  // DRINKS
  {
    id: 74,
    category:"drinks",
    name: "Кока кола 0,33",
    subtitle: "",
    desc: "",
    grams: "",
    price: "130",
    image: "https://idzuo.com/menuImages/drinks/coca_cola_0.33l.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 75,
    category:"drinks",
    name: "Кока кола зеро",
    subtitle: "",
    desc: "",
    grams: "",
    price: "130",
    image: "https://idzuo.com/menuImages/drinks/coca_cola_zero_limenka_0.33l.webp",
    cart: "Додајте у корпу",
  },

  // PIZZA
  {
    id: 76,
    category:"pizza",
    name: "Маргарита",
    subtitle: "",
    desc: "пелат, гауда, босиљак",
    grams: "",
    price: "700",
    image: "https://idzuo.com/menuImages/pizza/margarita.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 77,
    category:"pizza",
    name: "Каприћоза",
    subtitle: "",
    desc: "пелат, гауда, печурке, шунка, маслине",
    grams: "",
    price: "750",
    image: "https://idzuo.com/menuImages/pizza/kapricoza.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 78,
    category:"pizza",
    name: "Пеперони",
    subtitle: "",
    desc: "пелат, гауда, пеперони салама, халапењо папричица",
    grams: "",
    price: "780",
    image: "https://idzuo.com/menuImages/pizza/peperoni.webp",
    cart: "Додајте у корпу",
  },
    {
    id: 79,
    category:"pizza",
    name: "Панчета",
    subtitle: "",
    desc: "пелат, гауда, панчета, маслине",
    grams: "",
    price: "790",
    image: "https://idzuo.com/menuImages/pizza/panceta.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 80,
    category:"pizza",
    name: "Пица пилетина",
    subtitle: "",
    desc: "бели сос, гауда, пилетина, панчета, маслине",
    grams: "",
    price: "800",
    image: "https://idzuo.com/menuImages/pizza/piletina.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 81,
    category:"pizza",
    name: "Пица буткица",
    subtitle: "",
    desc: "пелат, гауда, димљена буткица, црвени лук, капар, рукола, аћето балзамико крема",
    grams: "",
    price: "820",
    image: "https://idzuo.com/menuImages/pizza/butkica.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 82,
    category:"pizza",
    name: "Пица kватро формађи",
    subtitle: "",
    desc: "пелат, гауда, горгонзола, трапист сир, пармезан",
    grams: "",
    price: "800",
    image: "https://idzuo.com/menuImages/pizza/kvatro-sir.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 83,
    category:"pizza",
    name: "Кватро стађони",
    subtitle: "",
    desc: "подељена на четири секције — буткица, вегетаријана, пеперони, каприћоза",
    grams: "",
    price: "820",
    image: "https://idzuo.com/menuImages/pizza/kvatro-stagoni.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 84,
    category:"pizza",
    name: "Вегетаријана",
    subtitle: "",
    desc: "пелат, гауда, чери парадајз, фета сир, свеж босиљак, рукола",
    grams: "",
    price: "800",
    image: "https://idzuo.com/menuImages/pizza/vegetarijana.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 85,
    category:"pizza",
    name: "Туна пица",
    subtitle: "",
    desc: "пелат, комади туне, црвени лук, капар, маслине, рукола",
    grams: "",
    price: "750",
    image: "https://idzuo.com/menuImages/pizza/tuna.webp",
    cart: "Додајте у корпу",
  },


  // DESERT
  {
    id: 86,
    category:"desert",
    name: "Питица са нутелом",
    subtitle: "",
    desc: "150г нутела, шумско воће, плазма",
    grams: "",
    price: "260",
    image: "https://idzuo.com/menuImages/dessert/pitica-sa-nutelom.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 87,
    category:"desert",
    name: "Питица са кремом",
    subtitle: "",
    desc: "150г еурокрем, шумско воће, плазма",
    grams: "",
    price: "240",
    image: "https://idzuo.com/menuImages/dessert/pitica-sa-kremom.webp",
    cart: "Додајте у корпу",
  },
  {
    id: 88,
    category:"desert",
    name: "Поховани сникерс",
    subtitle: "",
    desc: "120г поховани сникерс",
    grams: "",
    price: "250",
    image: "https://idzuo.com/menuImages/dessert/pohovani-snickers.webp",
    cart: "Додајте у корпу",
  },
 
];
